import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SAVE_MODULES = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.MODULES.SAVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_MODULES = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.MODULES.LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _DELETE_MODULE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.MODULES.DELETE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_MODULE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.MODULES.UPDATE;
  return callApi(url, "post", searchData && searchData);
};
